export default __webpack_public_path__ + "static/media/base.65c236f8.png";